import { ru } from '@/locale/admin/ru-RU'

export const adminLang = { ru }
